<template>
  <div class="menu-burger-wrapper">
    <div class="menu-burger-container">
      <div class="menu-burger-content">
        <div class="center-container">
          <menu-item :menu-info="menuInfo"
                     :is-active-visible="true"
                     @scrollTo="id => $emit('scrollTo', id)"/>
        </div>
        <div class="bottom-container">
          <media-block/>
          <div class="contact-container">
            <button-request/>
            <contact-title v-for="item in contacts"
                           :color="'white'"
                           :key="item.id"
                           :info="item"/>
          </div>
        </div>
      </div>

    </div>
    <div class="bg-container" v-if="!$isMobile">
      <img :src="getUrl(bgVector)" alt="bg">
    </div>
  </div>
</template>

<script>
import MenuItem from "@/components/widgets/MenuItem.vue";
import MainButton from "@/components/shared/MainButton.vue";
import MediaBlock from "@/components/entities/MediaBlock.vue";
import ContactTitle from "@/components/shared/ContactTitle.vue";
import ButtonRequest from "@/components/shared/static/ButtonRequest.vue";

export default {
  name: "MenuBurger",
  components: {ButtonRequest, ContactTitle, MediaBlock, MainButton, MenuItem},
  props: {
    menuInfo: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      contacts: [
        {

          id: 0,
          title: '+7 (499) 703 02 64',
          type: 'phone'
        },
        {

          id: 1,
          title: 'sales@avea-basis.ru',
          type: 'mail'
        },
      ],
      bgVector: 'bg-vector.webp'
    }
  },
}
</script>

<style scoped lang="scss">
.menu-burger-wrapper {
  top: 0;
  position: absolute;
  height: var(--calc-height);
  width: 100%;
  background: var(--color-gradient-deg);
  .menu-burger-container {
    margin: 0 auto;
    position: relative;
    z-index: 11;
    height: 100%;
    display: flex;
    flex-direction: column;
    max-width: calc(var(--var-max-width) + var(--padding-for-burger));

    .menu-burger-content {
      margin: auto 0 0;
      height: 100%;
      display: flex;
      flex-direction: column;
      justify-content: space-between;

      .center-container {
        display: flex;
        flex-direction: column;
      }
      .bottom-container {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: flex-end;

        .contact-container {
          display: flex;
          flex-direction: column;
        }
      }
    }
  }

  .bg-container {
    z-index: 10;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    position: absolute;
    & img {
      width: 100%;
      height: 100%;
    }
  }
}



@media (max-width: 3024px){
  .menu-burger-wrapper {
    .menu-burger-container {
      padding: 60px 60px 120px 60px;
      --padding-for-burger: 60px;

      .menu-burger-content {
        max-height: 815px;

        .center-container {
          row-gap: 60px;
        }

        .bottom-container {
          .contact-container {
            row-gap: 40px;
          }
        }
      }
    }
  }
}


@media (max-width: 1920px) {
  .menu-burger-wrapper {
    .menu-burger-container {
      padding: 60px;
      --padding-for-burger: 60px;

      .menu-burger-content {
        max-height: 695px;

        .center-container {
          row-gap: 52px;
        }

        .bottom-container {
          .contact-container {
            row-gap: 40px;
          }
        }
      }
    }
  }

}


@media (max-width: 1600px) {
  .menu-burger-wrapper {
    .menu-burger-container {
      padding: 40px 40px 120px 40px;
      --padding-for-burger: 40px;

      .menu-burger-content {
        max-height: 530px;

        .center-container {
          row-gap: 52px;
        }

        .bottom-container {
          .contact-container {
            row-gap: 32px;
          }
        }
      }
    }
  }
}
@media (max-height: 800px) {
  .menu-burger-wrapper {
    .menu-burger-container {
      padding: 40px;
      .menu-burger-content {
        max-height: 450px;

        .center-container {
          row-gap: 52px;
        }

        .bottom-container {
          .contact-container {
            row-gap: 24px;
          }
        }
      }
    }
  }
}

@media (max-width: 1400px) and (min-height: 801px) {
  .menu-burger-wrapper {
    .menu-burger-container {
      padding: 40px 40px 120px 40px;
      --padding-for-burger: 40px;
      .menu-burger-content {
        max-height: 530px;

        .center-container {
          row-gap: 52px;
        }

        .bottom-container {
          .contact-container {
            row-gap: 32px;
          }
        }
      }
    }
  }
}

@media (max-width: 1133px) {
  .menu-burger-wrapper {
    .menu-burger-container {
      padding: 40px;
      .menu-burger-content {
        max-height: 450px;

        .center-container {
          row-gap: 52px;
        }

        .bottom-container {
          .contact-container {
            row-gap: 24px;
          }
        }
      }
    }
  }

}

@media (max-width: 769px) {
  .menu-burger-wrapper {
    .menu-burger-container {
      padding: 64px 16px 24px;
      .menu-burger-content {
        max-height: 537px;
        .bottom-container {
          row-gap: 40px;
          flex-direction: column-reverse;
          align-items: flex-start;

          .contact-container {
            row-gap: 24px;
            ::v-deep(.contact-title-container) {
              column-gap: 16px;
              .main-title-container {
                font-size: 14px;
              }
              .icon-container {
                min-width: 20px;
                height: 20px;
              }
            }
          }
        }
      }
    }
  }
}

@media (max-width: 769px)  and (min-height: 720px) and (max-height: 1000px) {
  .menu-burger-wrapper {
    .menu-burger-container {
      padding: 64px 20px 24px;
    }
  }
}

@media (min-height: 600px) and (max-height: 630px){

  //8 plus
}

@media (max-width: 375px) {
  //se new
}

@media (max-width: 375px) and (min-height: 630px) {
  //x
}


@media (max-width: 320px) {
  //se old
}

@media (min-width: 3025px) {
  .menu-burger-wrapper {
    .menu-burger-container {
      padding: 80px 80px 258px 80px;
      --padding-for-burger: 80px;

      .menu-burger-content {
        max-height: 1450px;

        .center-container {
          row-gap: 100px;
        }

        .bottom-container {
          .contact-container {
            row-gap: 80px;
          }
        }
      }
    }
  }

}

</style>